import React from 'react';

const LandingPageDiveIntoMilesWidget = ({ title, description, icon } = props) => {
    return (
        <div className="offers-landing-page-to-dive-into-miles__widget">
            <img alt="" src={icon} />
            <h5>{title}</h5>
            <p>{description}</p>
        </div>
    )
};

export default LandingPageDiveIntoMilesWidget;